// extracted by mini-css-extract-plugin
export var hd = "index-module--hd--1iZPk";
export var sd = "index-module--sd--3Xoyo";
export var viewport = "index-module--viewport--UvNib";
export var carouselFrame = "index-module--carouselFrame--2I1DF";
export var carousel = "index-module--carousel--39MPD";
export var scroll = "index-module--scroll--2lUs3";
export var scrollItemOuter = "index-module--scrollItemOuter--39eKJ";
export var scrollItem = "index-module--scrollItem--hzmgq";
export var navButtons = "index-module--navButtons--1h5I1";
export var active = "index-module--active--3r8jI";
export var inactive = "index-module--inactive--3nenk";